module.exports = __webpack_public_path__ + "media/04-Buscar-picking-por-referencia.ad5aa32d.mp4";